
{
  "fr": {
    "modal_submit_button": {
      "button": "Continuer"
    }
  }
}
